<template>
  <div class="px-4">
    <div class="text-center pb-6">
      <router-link
        :to="{
          name: 'wizard',
          params: {
            site: questionsConfig.name
          }
        }"
        class="rounded bg-primary p-2 text-white"
      >
        ← Zurück zum Förder.Weg.Weiser
      </router-link>
    </div>
    <h2
      class="mt-2 mb-8 text-3xl leading-8 font-extrabold tracking-tight sm:text-4xl sm:leading-10 text-primary"
    >
      Impressum
    </h2>
    <p class="mb-5">
      Verantwortlicher für den Inhalt der Webseite und redaktionell
      Verantwortliche gemäß § 5 TMG
    </p>
    <p class="mb-4">
      Christian Dahm
      <br />
      <br />
      Klimaschutzberatung Jellinghaus Dahm GmbH
      <br />
      Hochstraße 115, 58095 Hagen
      <br />
      Registergericht AG Hagen HRB 12692
      <br />
      Geschäftsführung: Sabine Jellinghaus, Christian Dahm
    </p>
    <p class="mb-4">
      Ansprechpartner
      <br />
      Christian Dahm
      <br />
      Telefon: 0 23 31 - 625 42 56
      <br />
      E-Mail:
      <a href="mailto:dahm@jellinghaus-dahm.de">dahm@jellinghaus-dahm.de</a>
    </p>
  </div>
</template>

<script>
import { get } from 'vuex-pathify'
export default {
  name: 'Imprint',
  computed: {
    questionsConfig: get('questions/config')
  }
}
</script>

<style lang="scss" scoped></style>
